import { motion, useReducedMotion } from 'motion/react';

import ScrollableList from 'components/common/ScrollableList';
import ServingSpaghetti from 'images/familyHome/serving-spaghetti.jpg';

const PARENT_VARIANT = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const createSlideInVariants = prefersReducedMotion => ({
  hidden: { opacity: 0, y: prefersReducedMotion ? 0 : 100 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      type: prefersReducedMotion ? 'tween' : 'spring',
    },
  },
});

const Tip = ({ tipHeading, tipBody }) => {
  const prefersReducedMotion = useReducedMotion();
  const slideInVariants = createSlideInVariants(prefersReducedMotion);

  return (
    <motion.li
      className="flex min-w-80 flex-1 flex-col gap-4 rounded-xl bg-white-110 p-6 pb-10 "
      variants={slideInVariants}
    >
      <h3 className="h5 text-center font-bold text-green-140">{tipHeading}</h3>
      <p className="text text-center text-green-140">{tipBody}</p>
    </motion.li>
  );
};

Tip.propTypes = {
  tipHeading: PropTypes.string.isRequired,
  tipBody: PropTypes.string.isRequired,
};

const DinnerTips = ({ data: { title, tips } }) => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="flex justify-center bg-white-110 px-4 pb-14 pt-8 bp2:py-20">
      <motion.div
        variants={PARENT_VARIANT}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        className="relative flex w-full max-w-7xl flex-col items-center gap-32 rounded-2xl bg-family-beige-100 bg-cover bg-center bg-no-repeat bp2:bg-[center_top_-8rem] bp3:gap-64"
        style={{ backgroundImage: `url(${ServingSpaghetti})` }}
      >
        <div className="absolute left-0 right-0 top-0 h-40 rounded-t-2xl bg-gradient-to-b from-green-140 to-transparent opacity-50 mix-blend-multiply bp2:h-80" />
        <motion.h2
          initial={{ opacity: 0, y: prefersReducedMotion ? 0 : 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, type: 'spring' }}
          viewport={{ once: true, amount: 0.5 }}
          className="h1 z-10 px-4 py-6 text-center text-white-110 bp2:pb-8 bp2:pt-12"
        >
          {title}
        </motion.h2>
        <div className="w-full">
          <ScrollableList
            numSlides={3}
            buttonStyles="invisible bp1:visible shadow-xl bg-white-110 border-2 border-solid border-green-140 hover:bg-white-110 hover:brightness-90 mx-4 top-1/2 -translate-y-1/2"
            iconStyles="iconLg text-green-140"
            slidesContainerStyles="items-stretch items-end p-4 gap-4"
          >
            {tips.map(tip => (
              <Tip key={tip.key} {...tip} />
            ))}
          </ScrollableList>
        </div>
      </motion.div>
    </section>
  );
};

DinnerTips.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    tips: PropTypes.arrayOf(
      PropTypes.shape({
        tipHeading: PropTypes.string.isRequired,
        tipBody: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

export default DinnerTips;
